<template>
  <div class="after_sales_reasons_page">
    <div class="title_box flex_center">
      <img src="./image/order_icon.png" class="order_icon" />
      <div class="flex_column">
        <div class="order_title">售后申请</div>
        <div class="order_subtitle">
          完善售后信息, 以便我们为您更好的解决问题!
        </div>
      </div>
    </div>
    <div class="content_box">
      <el-form :model="form" label-width="100px" :rules="rules">
        <el-form-item label="订单号">
          <el-input
            v-model="form.orderNo"
            placeholder="请输入订单号"
            style="width: 400px"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="问题描述" prop="refundDes">
          <el-input
            v-model="form.refundDes"
            placeholder="请输入问题描述"
            style="width: 400px"
            type="textarea"
            :disabled="refundId ? true : false"
          ></el-input>
        </el-form-item>
        <el-form-item label="意向方案" prop="schemeStatus">
          <div class="flex_center">
            <el-select
              v-model="form.schemeStatus"
              placeholder="请选择"
              class="mr12 width150"
              :disabled="refundId ? true : false"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              v-model="form.refundPrice"
              v-if="form.schemeStatus === 'REDUCE_PRICE'"
              :placeholder="`最大优惠金额${orderInfo.orderPrice}`"
              style="width: 200px"
              :disabled="refundId ? true : false"
            ></el-input>
            <span
              v-if="
                form.schemeStatus === 'REFUND_PRICE' ||
                form.schemeStatus === 'REDUCE_PRICE'
              "
              style="color: #a9a1a1"
            >
              审核通过之后会将退款返回到预存款
            </span>
            <div class="flex_center" v-if="form.schemeStatus === 'REPRINT'">
              <el-input
                v-model="form.reprintNum"
                :placeholder="`最大补印数量${orderInfo.orderNum}`"
                style="width: 180px"
                class="mr12"
                :disabled="refundId ? true : false"
              ></el-input>
              <el-input
                v-model="form.printNum"
                :placeholder="`最大补印款数${orderInfo.printNum}`"
                style="width: 180px"
                class="mr12"
                :disabled="refundId ? true : false"
              ></el-input>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传凭证" v-if="!refundId">
          <div>
            为了快速为您解决售后问题，请把有问题的成品十几张平铺放在一起，单张有问题的地方漏出来拍个图片。
          </div>
          <div v-if="srcList.length > 0">
            <div class="flex_wrap">
              <div
                class="img_box"
                v-for="(item, index) of srcList"
                :key="index"
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="item"
                  :preview-src-list="srcList"
                >
                </el-image>
                <div
                  class="delete_icon el-icon-error"
                  @click="toDeleteImg(index)"
                ></div>
              </div>
              <div class="again_upload_box">
                <input type="file" accept="image/" @change="handleUpdataFile" />
                <i class="el-icon-box again_upload_icon"></i>
                <div class="bold" style="width: 100px">继续上传</div>
              </div>
            </div>
          </div>
          <div class="again_upload_box" v-else>
            <input type="file" accept="image/" @change="handleUpdataFile" />
            <i class="el-icon-box upload_icon"></i>
            <div class="bold" style="width: 100px">点击上传</div>
          </div>
          <span style="line-height: 15px"
            >支持jpg/png/gif格式的图片,不大于10M。支持MP4格式视频,不大于10M。
            请补充支持售后原因的快递面单、货物标签、货物整体、第三方交易详情等相关证明。</span
          >
        </el-form-item>
        <el-form-item label="原凭证" v-if="form.refundImage && refundId">
          <div class="tips bold">
            温馨提示：重新上传凭证会原来凭证将不会保留
          </div>
          <el-image
            style="width: 100px; height: 100px"
            :src="form.refundImage"
            :preview-src-list="[form.refundImage]"
          >
          </el-image>
        </el-form-item>
        <el-form-item label="联系电话">
          <div class="flex_center">
            <el-input
              v-model="form.phone"
              placeholder="请输入联系电话"
              style="width: 200px"
              class="mr12"
              :disabled="refundId ? true : false"
            ></el-input>
            联系QQ：
            <el-input
              v-model="form.qq"
              placeholder="请输入QQ"
              style="width: 200px"
              :disabled="refundId ? true : false"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="" v-if="orderId">
          <div class="flex_center">
            <el-button type="primary" @click="toSubmit">提 交</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  orderDetailApi,
  orderRefundApi,
  refundDetailApi,
  getOssAuth,
  personalInfoApi,
} from "../../api/index";
export default {
  data() {
    return {
      orderId: 0,
      refundId: 0,
      form: {
        orderNo: "",
        createTime: "",
        refundDes: "",
        replay: "replay",
        refundStatus: "VERIFY",
        schemeStatus: "REFUND_PRICE",
        refundImage: "",
        phone: "",
        qq: "",
        reprintNum: null,
        printNum: null,
        refundPrice: null,
      },
      srcList: [],
      rules: {
        refundDes: [
          { required: true, message: "请输入问题描述", trigger: "blur" },
        ],
        schemeStatus: [
          { required: true, message: "请选择意向方案", trigger: "change" },
        ],
        refundImage: [
          { required: true, message: "请上传凭证", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      options1: [
        {
          value: "REFUND_PRICE",
          label: "退货减款",
        },
        {
          value: "REFUND",
          label: "退货",
        },
        {
          value: "REPRINT",
          label: "补印",
        },
        {
          value: "REDUCE_PRICE",
          label: "减款",
        },
        {
          value: "OTHER",
          label: "其他",
        },
      ],
      orderInfo: {
        orderNum: 1, //印刷数量
        printNum: 1, //印刷款数
        orderPrice: 1,
      },
    };
  },
  created() {},
  activated() {
    if (this.$route.query.refundId) {
      this.orderId = null;
      this.cleanForm();
      // 售后记录
      this.refundId = +this.$route.query.refundId;
      this.getDetail();
    }
    // 初次申请售后
    if (this.$route.query.orderId) {
      this.refundId = null;
      this.cleanForm();
      this.getUserInfo();
      this.orderId = this.$route.query.orderId;
      this.getOrderInfo();
    }
  },
  mounted() {
    // this.getInfo();
  },
  methods: {
    cleanForm() {
      this.form = {
        orderNo: "",
        createTime: "",
        refundDes: "",
        replay: "",
        refundStatus: "",
        schemeStatus: "",
        refundImage: "",
        phone: "",
        qq: "",
        reprintNum: null,
        printNum: null,
        refundPrice: null,
      };
      this.srcList = [];
      this.orderInfo = {
        orderNum: 1, //印刷数量
        printNum: 1, //印刷款数
        orderPrice: 1,
        phone: "",
      };
    },
    getUserInfo() {
      personalInfoApi()
        .then((res) => {
          if (res.resultStatus) {
            const result = res.resultData;
            this.form.phone = result.phone ? result.phone : "";
          } else {
            this.form.phone = "";
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getOrderInfo() {
      orderDetailApi({
        orderId: this.orderId,
      }).then((res) => {
        if (res.resultStatus) {
          const result = res.resultData.order;
          this.form.orderNo = result ? result.orderNo : "";
          this.form.refundImage = "";
          this.orderInfo = {
            orderNum: result.orderNum ? result.orderNum : 1, //印刷数量
            printNum: result.printNum ? result.printNum : 1, //印刷款数
            orderPrice: result.orderPrice ? result.orderPrice : 1,
          };
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    getDetail() {
      refundDetailApi({
        refundId: this.refundId,
      }).then((res) => {
        if (res.resultStatus) {
          const result = res.resultData;
          this.form.orderNo = result ? result.orderNo : "";
          this.form.createTime = result ? result.createTime : "";
          this.form.refundDes = result ? result.refundDes : "";
          this.form.replay = result ? result.replay : "";
          this.form.refundStatus = result ? result.refundStatus : "";
          this.form.schemeStatus = result ? result.schemeStatus : "";
          this.form.refundImage = result ? result.refundImage : "";
          this.form.phone = result ? result.phone : "";
          this.form.qq = result ? result.qq : "";
          this.form.reprintNum = result ? result.reprintNum : null;
          this.form.printNum = result ? result.printNum : null;
          this.form.refundPrice = result ? result.refundPrice : null;
          if (this.form.refundImage) {
            this.srcList = this.form.refundImage.split(";");
          }
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    // 上传文件
    handleUpdataFile(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        if (file) {
          const form = new FormData();
          form.append("file", file);
          getOssAuth(form).then((res) => {
            if (res.resultStatus) {
              const fileLink = res.resultData.fileLink;
              this.srcList.push(fileLink);
            }
          });
        }
      }
    },
    toSubmit() {
      this.form.refundImage = this.srcList.join(";");
      if (!this.form.refundImage) {
        this.$message.warning("请上传凭证");
        return;
      }
      orderRefundApi({
        orderId: this.orderId,
        refundDes: this.form.refundDes,
        schemeStatus: this.form.schemeStatus,
        refundImage: this.form.refundImage,
        phone: this.form.phone,
        qq: this.form.qq,
        reprintNum: this.form.reprintNum,
        printNum: this.form.printNum,
        refundPrice: this.form.refundPrice,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("提交成功");
          this.$router.push({
            name: "orderManege",
          });
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
    toDeleteImg(index) {
      this.srcList.splice(index, 1);
    },
  },
};
</script>

<style lang="less">
.after_sales_reasons_page {
  width: 100%;
  min-height: 100%;
  border: 1px solid #e1e1e1;
  padding: 20px;
  box-sizing: border-box;
  .title_box {
    margin-bottom: 12px;
  }
  @media screen and (min-width: 480px) {
    .width150 {
      width: 150px;
    }
    .width200 {
      width: 200px;
    }
  }
  @media only screen and (max-width: 480px) {
    .width150 {
      width: 150px;
    }
    .width200 {
      width: 200px;
    }
  }
  .content_box {
    width: 100%;
    box-sizing: border-box;
    .table_content {
      width: 100%;
      box-sizing: border-box;
    }
    .statics {
      font-size: 14px;
      font-weight: bold;
      margin-top: 12px;
    }
  }
}
.price {
  color: #00a0e9;
}
.upload_box {
  width: 400px;
  height: 150px;
  background: #f6f7f8;
  border-radius: 3px;
  border: 1px dashed #e1e1e1;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 13px 30px;
  box-sizing: border-box;
  input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    font-size: 0;
    cursor: pointer;
    opacity: 0;
  }
  span {
    font-size: 13px;
    color: #999;
  }
  .bold {
    font-size: 16px;
    font-weight: bold;
  }
}
.upload_icon {
  font-size: 24px;
  color: #00a0e9;
}
.tips {
  color: red;
  font-size: 14px;
}
.img_box {
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  position: relative;
  .delete_icon {
    font-size: 20px;
    cursor: pointer;
    position: absolute;
    right: -2px;
    top: -2px;
  }
}
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>